import { useState } from 'react';

import cn from 'classnames';
import { useTracking } from 'hooks/analytic-tracking';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import Alert from 'components/Alert/Alert';
import { IconButton } from 'components/IconButton/IconButton';

import styles from './EmployeeDetails.module.scss';
import { CandidateCustomFields } from './tabs/CandidateCustomFields/CandidateCustomFields';
import { EmployeeInformation } from './tabs/EmployeeInformation/EmployeeInformation';

export const EmployeeDetails = ({
  candidate,
  company,
  user,
  brands,
  teams = [],
  companyUsers,
  customFields,
  handleCandidateUpdate = () => {},
  sendRequestEmail = () => {},
}) => {
  const { t } = useTranslation();
  const [showRequestAlert, setShowRequestAlert] = useState(false);

  const { trackEvent } = useTracking(user);

  const onUpdate = async data => {
    await handleCandidateUpdate(data);
    setShowRequestAlert(!candidate.completed_at && !candidate.canceled);
    trackEvent('Candidate Updated', {
      candidateId: candidate.id,
      data: data,
    });
  };

  const sendNewRequest = () => {
    setShowRequestAlert(false);
    sendRequestEmail();
    trackEvent('Candidate Request Resent', {
      candidateId: candidate.id,
      resendReason: 'Manual Sending New Request',
    });
  };

  return (
    <div className={cn('d-flex', 'card', 'card-with-border', 'card--small')}>
      <Alert
        show={showRequestAlert}
        title="Would you like to send a new request to the candidate?"
        ok="Send New Request"
        onOk={sendNewRequest}
        cancel="No Thanks"
        onCancel={() => setShowRequestAlert(false)}
      />
      <div className="u-width-100">
        <div className={cn('d-flex', 'justify-content-between', 'align-items-center', 'u-padding')}>
          <div>
            <div className="title-3">{t('employee.tabs.employee_details.title')}</div>
          </div>
          {!candidate.completed_at && !candidate.canceled && (
            <IconButton
              icon="send"
              tip="Send new request"
              onClick={() => setShowRequestAlert(true)}
              disabled={candidate.partner_application_id && !candidate.partner_application_started}
            />
          )}
        </div>

        <Tabs
          defaultActiveKey="information"
          className={cn(styles.tabs, 'tabs', 'padding-small', 'no-padding')}
          mountOnEnter
          unmountOnExit>
          <Tab eventKey="information" title="Information">
            <EmployeeInformation
              candidate={candidate}
              brands={brands}
              company={company}
              teams={teams}
              companyUsers={companyUsers}
              onUpdate={onUpdate}
            />
          </Tab>
          {customFields?.length > 0 && (
            <Tab eventKey="custom_fields" title="Custom Fields">
              <CandidateCustomFields
                candidate={candidate}
                customFields={customFields}
                onUpdate={onUpdate}
              />
            </Tab>
          )}
        </Tabs>
      </div>
    </div>
  );
};
